import PrazoFaturamentoHandler from "@/common/contabil/prazo/PrazoFaturamentoHandler";
import ContabilShortcutHandler from "@/composables/contabil/Shortcuts/ContabilHandler";
import ShortcutObrigacoesHandler from "@/composables/contabil/Shortcuts/obrigacoes/ObrigacoesContabilHandler";
import { IShortcutHandler } from "@/core/composables/F360DateShortcuts/types";
import AutocontratacaoHttpGateway from "@/services/contabil/autocontratacao/AutocontratacaoHttpGateway";
import { IDashboardGateway } from "@/services/contabil/dashboard/gateways/DashboardGateway";
import DashboardHttpGateway from "@/services/contabil/dashboard/gateways/DashboardHttpGateway";
import { IDashboardLucroGateway } from "@/services/contabil/dashboard/gateways/DashboardLucroGateway";
import DashboardLucroHttpGateway from "@/services/contabil/dashboard/gateways/DashboardLucroHttpGateway";
import ObrigacoesFiscais from "@/services/contabil/dashboard/gateways/ObrigacoesFiscais";
import ReceitaFederal from "@/services/contabil/dashboard/gateways/ReceitaFederal";
import Empecilhos from "@/services/contabil/dashboard/gateways/entity/Empecilhos";
import { DashboardContabilDITypes } from "@/services/contabil/dashboard/types";
import { IDiagnosticoGateway } from "@/services/contabil/diagnostico/gateways/DiagnosticoGateway";
import DiagnosticoHttpGateway from "@/services/contabil/diagnostico/gateways/DiagnosticoHttpGateway";
import { ISharedGateway } from "@/services/contabil/shared/gateways/SharedGateway";
import SharedHttpGateway from "@/services/contabil/shared/gateways/SharedHttpGateway";
import { ContabilDITypes } from "@/services/contabil/types";
import ReceitaFederalInteractor from "@/views/contabil/dashboard/widgets/CadinSituacaoFiscal/ReceitaFederalService";
import { IReceitaFederalService } from "@/views/contabil/dashboard/widgets/CadinSituacaoFiscal/ReceitaFederalUseCase";
import { ContainerModule } from "inversify";
import { diContainer } from "..";
import { controleDebitosContainer } from "./controleDebitos";
import {
  IUsuariosPorEmpresaGateway,
  usuariosPorEmpresaGatewayDI
} from "@/views/contabil/comunicacao/ports/UsuarioPorEmpresaGateway";
import {
  IUsuarioPorEmpresaUseCase,
  usuariosPorEmpresaUseCaseDI
} from "@/views/contabil/comunicacao/ports/UsuarioPorEmpresaUseCase";
import { UsuarioPorEmpresaGatewayAdapter } from "@/views/contabil/comunicacao/adapters/UsuarioPorEmpresaGatewayAdapter";
import { UsuarioPorEmpresaUseCase } from "@/views/contabil/comunicacao/adapters/UsuarioPorEmpresaUseCaseAdapter";
import { PeriodoDocumentoDisponivel } from "@/common/contabil/PeriodoDocumentosDisponiveis";
import { CSATContainer } from "@/views/contabil/components/ContabilCSAT/container";
import { visaoEstrategicaContainer } from "@/views/contabil/dashboardTributacao/container";

const contabilContainer = new ContainerModule((bind) => {
  bind<IDashboardGateway>(ContabilDITypes.DASHBOARD_GATEWAY).to(
    DashboardHttpGateway
  );
  bind<IDiagnosticoGateway>(ContabilDITypes.DIAGNOSTICO_GATEWAY).to(
    DiagnosticoHttpGateway
  );
  bind<ISharedGateway>(ContabilDITypes.SHARED_GATEWAY).to(SharedHttpGateway);
  bind<IDashboardLucroGateway>(ContabilDITypes.DASHBOARD_LUCRO_GATEWAY).to(
    DashboardLucroHttpGateway
  );
  bind<IShortcutHandler<string>>(ContabilDITypes.OBRIGACOES_SHORTCUTS).to(
    ShortcutObrigacoesHandler
  );
  bind<IShortcutHandler<unknown>>(ContabilDITypes.CONTABIL_SHORTCUTS).to(
    ContabilShortcutHandler
  );
  bind<AutocontratacaoHttpGateway>(ContabilDITypes.AUTOCONTRATACAO_GATEWAY).to(
    AutocontratacaoHttpGateway
  );
  bind(PrazoFaturamentoHandler).to(PrazoFaturamentoHandler);
  bind<IUsuariosPorEmpresaGateway>(usuariosPorEmpresaGatewayDI).to(
    UsuarioPorEmpresaGatewayAdapter
  );
  bind<IUsuarioPorEmpresaUseCase>(usuariosPorEmpresaUseCaseDI).to(
    UsuarioPorEmpresaUseCase
  );
  bind<PeriodoDocumentoDisponivel>(PeriodoDocumentoDisponivel).toSelf();
  diContainer.load(CSATContainer);
  diContainer.load(visaoEstrategicaContainer);
});
const contabilDashboardContainer = new ContainerModule((bind) => {
  bind<IReceitaFederalService>(DashboardContabilDITypes.RECEITA_FEDERAL_SERVICE)
    .to(ReceitaFederalInteractor)
    .inRequestScope();
  bind(ObrigacoesFiscais).to(ObrigacoesFiscais).inRequestScope();
  bind(ReceitaFederal).toSelf().inRequestScope();
  bind(Empecilhos).toSelf().inRequestScope();
  diContainer.load(controleDebitosContainer);
});

const contabilDashboardEstrategicaContainer = new ContainerModule(() => {
  //teste
});

export {
  contabilContainer,
  contabilDashboardContainer,
  contabilDashboardEstrategicaContainer
};
